export const CARD_MIN_WIDTH = '28rem';

export const DATE_TIME_FORMAT = 'MM/dd/yyyy h:mm aa';
export const TIME_FORMAT = 'h:mm aa';

export const BUILDING_GUIDE_FORM = 'BUILDING_GUIDE_FORM';

export const CTA_TYPE_OPTIONS = [
  { label: 'External Link', value: 'external_link' },
  { label: 'In-App Link', value: 'in_app_link' },
];

export const IN_APP_LINK_CATEGORIES = [
  'service_request',
  'service_request_update',
  'service_request_feedback',
  'service_request_list',
  'thread',
  'delivery',
  'visitor_log',
  'broker_log',
  'visitor',
  'broker',
  'amenity',
  'amenity_type',
  'amenity_reservation',
  'amenity_reservations_home_page',
  'notification_preferences',
  'system',
  'system_settings',
  'open_door',
  'community_marketplace',
  'community_feed',
  'community_thread',
  'community_content_approval',
  'my_account',
  'rent_payment_tab',
];

export const CATEGORIES = [
  { label: 'Team', value: 'team' },
  { label: 'Highlight', value: 'highlight' },
  { label: 'Information', value: 'information' },
  { label: 'Amenity', value: 'amenity' },
  { label: 'Parking', value: 'parking' },
  { label: 'Quick Tip', value: 'quick_tip' },
  { label: 'Resident Services', value: 'resident_services' },
];

export const LAYOUTS = [
  { label: 'Center Align', value: 'center_align' },
  { label: 'Side Align', value: 'side_align' },
  { label: 'Wi-Fi', value: 'wifi' },
  { label: 'Location', value: 'location' },
];
